import {defineStore} from 'pinia'

export const useStore = defineStore('store', {
  state: () => {
    return {
      breadCrumbList: []
    }
  },
  actions: {
    setBreadCrumbList(data) {
      this.breadCrumbList = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js